import { render, staticRenderFns } from "./TransferArchive.vue?vue&type=template&id=19973053&"
import script from "./TransferArchive.vue?vue&type=script&lang=js&"
export * from "./TransferArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports